import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./index.css";
import HeaderTopbar2 from "../HeaderTopbar2/HeaderTopbar2";
import MobileMenu from "../MobileMenu/MobileMenu";
import Logo from "../../images/logo-2.png";

const Header3 = (props) => {
  const [menuActive, setMenuState] = useState(false);
  const SubmitHandler = (e) => {
    e.preventDefault();
  };

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <header
      id="header"
      className={` ${props.topbarNone}`}
      style={
        {
          // backgroundImage: 'url(/img/home/background.gif)', // Update the path to your GIF
          // backgroundSize: 'cover',
          // backgroundPosition: 'center',
        }
      }
    >
      {/* <HeaderTopbar2 /> */}
      <div style={{ marginBottom: "40px" }}></div>
      <div className={`wpo-site-header ${props.hclass}`}>
        <nav className="navigation navbar navbar-expand-lg navbar-light navbar-padding">
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-lg-3 col-md-3 col-3 d-lg-none dl-block">
                <div className="mobail-menu">
                  <MobileMenu />
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-6">
                <div className="navbar-header">
                  <Link
                    onClick={ClickHandler}
                    className="navbar-brand"
                    to="/"
                  >
                    <img
                      src={Logo}
                      alt=""
                      style={{ height: "40px", width: "100px",marginLeft:"30px" }}
                    />
                  </Link>
                </div>
              </div>
              <div className="col-lg-6 col-md-1 col-1">
                <div
                  id="navbar"
                  className="collapse navbar-collapse navigation-holder"
                >
                  <ul className="nav navbar-nav mb-2 mb-lg-0">
                    <li className="menu-item-has-children">
                      <Link onClick={ClickHandler} to="/">
                        Home
                      </Link>
                    </li>
                    <li className="menu-item-has-children">
                      <Link to="/web-development-services">Services</Link>
                      <ul className="sub-menu services-sub-menu">
                        <li className="solutions-menu-item">
                          <Link onClick={ClickHandler} to="/web-development-services">
                            WebCraft
                            <br />
                            <span className="item-span">
                              Web Development Services
                            </span>
                          </Link>
                        </li>
                        <li className="solutions-menu-item">
                          <Link onClick={ClickHandler} to="/digital-marketing-services">
                            Digitally
                            <br />
                            <span className="item-span">
                              Digital Marketing Services
                            </span>
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li className="menu-item-has-children">
                      <Link to="/real-estate-solutions">Solutions</Link>
                      <ul className="sub-menu solutions-sub-menu">
                        <li className="solutions-menu-item">
                          <Link onClick={ClickHandler} to="/real-estate-solutions">
                            Real Estate
                            <br />
                            <span className="item-span">
                              Real estate agent solutions
                            </span>
                          </Link>
                        </li>
                        <li className="solutions-menu-item">
                          <Link onClick={ClickHandler} to="/healthcare-it-solutions">
                            Health Care
                            <br />
                            <span className="item-span">
                              IT solutions for healthcare
                            </span>
                          </Link>
                        </li>
                        <li className="solutions-menu-item">
                          <Link onClick={ClickHandler} to="/fashion-ecommerce-solutions">
                            Fashion
                            <br />
                            <span className="item-span">
                              Beautifying fashion industry
                            </span>
                          </Link>
                        </li>
                        <li className="solutions-menu-item">
                          <Link onClick={ClickHandler} to="/it-consulting-solutions">
                            IT Solutions
                            <br />
                            <span className="item-span">
                              One stop for IT needs
                            </span>
                          </Link>
                        </li>
                        <li className="solutions-menu-item">
                          <Link onClick={ClickHandler} to="/education-technology-solutions">
                            Education
                            <br />
                            <span className="item-span">
                              TI partner in EdTech needs
                            </span>
                          </Link>
                        </li>
                        <li className="solutions-menu-item">
                          <Link onClick={ClickHandler} to="/manufacturing-digital-solutions">
                            Manufacturing
                            <br />
                            <span className="item-span">
                              Solution for you plant
                            </span>
                          </Link>
                        </li>
                        <li className="solutions-menu-item">
                          <Link onClick={ClickHandler} to="/finance-software-solutions">
                            Finance
                            <br />
                            <span className="item-span">
                              Solutions for Fintech growth
                            </span>
                          </Link>
                        </li>
                        <li className="solutions-menu-item">
                          <Link onClick={ClickHandler} to="/custom-digital-solutions">
                            Home & Others
                            <br />
                            <span className="item-span">
                              Small or Individual business
                            </span>
                          </Link>
                        </li>
                      </ul>
                    </li>
                    {/* <li>
                      <Link onClick={ClickHandler} to="/blog">
                        Portfolio
                      </Link>
                    </li> */}
                    <li>
                      <Link onClick={ClickHandler} to="/about">
                        About Us
                      </Link>
                    </li>
                    {/* <li>
                      <Link onClick={ClickHandler} to="/blog">
                        Blog
                      </Link>
                    </li> */}
                  </ul>
                </div>
              </div>
              <div className="col-lg-3 col-md-2 col-2">
                <div className="header-right">
                  <div className="close-form">
                    <Link
                      onClick={ClickHandler}
                      className="theme-btn"
                      to="/contact"
                    >
                      Contact Us
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header3;
